import type { TypeComponentLinkEntry } from '@contentful-types/component-link'
import { ComponentLinkTargetTab } from '@contentful-types/component-link'

/**
 * Creates a TypeComponentLinkEntry from a URL string
 * This is useful for creating link entries programmatically without CMS data
 */
export function createLinkEntry(
  url: string,
  options: {
    title?: string
    targetTab?: ComponentLinkTargetTab
    appendCurrentQueryParams?: boolean
    showArrow?: boolean
    internalName?: string
  } = {},
): TypeComponentLinkEntry {
  const {
    title,
    targetTab = ComponentLinkTargetTab.Self,
    appendCurrentQueryParams = false,
    showArrow = false,
    internalName = 'Generated Link',
  } = options

  return {
    sys: {
      id: `generated-link-${internalName.toLowerCase().replaceAll(' ', '-')}-${title?.toLowerCase().replaceAll(' ', '-') ?? ''}`,
      type: 'Entry',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      revision: 1,
      contentType: {
        sys: {
          type: 'Link',
          linkType: 'ContentType',
          id: 'componentLink',
        },
      },
      locale: 'en-US',
    },
    fields: {
      internalName,
      targetUrl: url,
      title,
      targetTab,
      appendCurrentQueryParams,
      showArrow,
    },
  } as TypeComponentLinkEntry
}
